import Header from '../components/header/index.jsx';
import MyStories from './my-stories.jsx';
import NotFound from './not-found.jsx';
import React, {Suspense, lazy} from 'react';
import StoryList from './story-list/index.jsx';
import {Private} from '@apps-common/auth-react';
import {Redirect, Route, Switch} from 'react-router-dom';
import {elementType} from 'prop-types';

const Viewer = lazy(() => import('./viewer/index.jsx'));
const Wizard = lazy(() => import('./wizard/index.jsx'));

function LoginCallback() {
  return <Redirect to="/" />;
}

function PrivateRoute({component: Component, ...props}) {
  return (
    <Route {...props}>
      <Private>
        <Component />
      </Private>
    </Route>
  );
}

PrivateRoute.propTypes = {
  component: elementType.isRequired,
};

const Pages = () => {
  return (
    <>
      <Header />
      <Suspense>
        <Switch>
          <Route exact path="/" component={StoryList} />
          <PrivateRoute exact path="/my-stories" component={MyStories} />
          <PrivateRoute exact path="/create" component={Wizard} />
          <Route exact path="/callback" component={LoginCallback} />
          <Route exact path="/:id" component={Viewer} />
          <Route component={NotFound} />
        </Switch>
      </Suspense>
    </>
  );
};

export default Pages;
